// extracted by mini-css-extract-plugin
export var button = "Tabs-module--button--mDBgm";
export var component = "Tabs-module--component--IUj52";
export var componentInner = "Tabs-module--componentInner--Ml19i";
export var item = "Tabs-module--item--+atCR";
export var list = "Tabs-module--list--uOlCk";